import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import GameInterface from './index';
import store from '../../state/store';
import { setNewAgsiBet, setFeatureModeEnabled } from '../../state/actions/agsi';
import { setSpinEvent } from '../../state/slices/spinEvent/spinEvent';
import SPIN_PHASE from './helpers/spinPhases';

var Agsi = /*#__PURE__*/function (_GameInterface) {
  _inherits(Agsi, _GameInterface);

  var _super = _createSuper(Agsi);

  /**
   * GameInterface constructor
   * @param {Object} args
   * @param {import("../Constants").BetInfo} args.BetInfo
   * @param {Function} args.ExitFunc
   */
  function Agsi(args) {
    var _this;

    _classCallCheck(this, Agsi);

    _this = _super.call(this, args);

    _this.kvpParserEvent = function (event) {};

    _this.jsonParserEvent = function (event) {
      var playerId = store.getState().playerInfo.playerId;
      var gameId = store.getState().gameInfo.gameId;
      var _store$getState$lastS = store.getState().lastSpinEvents.balanceAfter,
          balance = _store$getState$lastS === void 0 ? null : _store$getState$lastS;
      var featureModeEnabled = store.getState().agsi.featureModeEnabled;

      switch (event.action) {
        case 'stakeUpdate':
          store.dispatch(setNewAgsiBet(event.data.stake));
          break;

        case 'gameRoundStarted':
          /* 
            Agsi does not offer a specific event for free spins 
            so we use the 'featureModeEnabled' flag to know if the player is 
            inside free spins/jackpots/bonuses or real spins 
          */
          if (!featureModeEnabled) {
            _this.currentBet = store.getState().agsi.betValue;
            store.dispatch(setSpinEvent({
              playerId: playerId,
              createdTimestamp: Date.now(),
              spinPhase: SPIN_PHASE.WAGE,
              amount: _this.currentBet,
              gameId: gameId
            }));
          }

          break;

        case 'insufficientFunds':
          _this._outOfCoins();

          _this.showOutOfCoinsScreen();

          break;

        case 'enableFeatureMode':
          store.dispatch(setFeatureModeEnabled(true));
          break;

        case 'disableFeatureMode':
          store.dispatch(setFeatureModeEnabled(false));
          break;

        case 'winningsUpdate':
          if (event.data.winnings > 0 && !featureModeEnabled) store.dispatch(setSpinEvent({
            playerId: playerId,
            createdTimestamp: Date.now(),
            spinPhase: SPIN_PHASE.WIN,
            gameId: gameId,
            amount: event.data.winnings
          }));
          break;

        case 'gameRoundEnded':
          if (!featureModeEnabled) {
            _this.AddSpinXP(_this.currentBet);
          }

          break;

        case 'balancesUpdate':
          if (!featureModeEnabled) store.dispatch(setSpinEvent({
            balanceBefore: balance ? balance : event.data.balances.cash,
            balanceAfter: event.data.balances.cash
          }));
      }
    };

    _this.currentBet = 0;
    return _this;
  }
  /**
   * Agsi Event Handler
   * @param {import("./helpers/parseEvent").ParsedEvent} event
   */


  return _createClass(Agsi);
}(GameInterface);

export default Agsi;